import { render, staticRenderFns } from "./AgendarCita.vue?vue&type=template&id=2e2fc3d6&scoped=true&lang=pug"
import script from "./AgendarCita.vue?vue&type=script&lang=js"
export * from "./AgendarCita.vue?vue&type=script&lang=js"
import style0 from "./AgendarCita.vue?vue&type=style&index=0&id=2e2fc3d6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e2fc3d6",
  null
  
)

export default component.exports